import { NomenclatureState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const getters = {
  nonConvHonoraria: (state: NomenclatureState) => state.non_conv_honoraria,
};

const { read } = getStoreAccessors<NomenclatureState, State>('');

export const readNonConvHonoraria = read(getters.nonConvHonoraria);
